import { render } from "./TrainingAttendingView.vue?vue&type=template&id=04daaa48&scoped=true"
import script from "./TrainingAttendingView.vue?vue&type=script&lang=js"
export * from "./TrainingAttendingView.vue?vue&type=script&lang=js"

import "./TrainingAttendingView.vue?vue&type=style&index=0&id=04daaa48&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04daaa48"]])

export default __exports__